import { Box, Stack, styled } from '@ltvco/refresh-lib/theme';
import { FiberNew } from '@mui/icons-material';

export const BusinessPromoSection = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$compact',
})<{ $compact: boolean }>(({ theme, $compact }) => ({
  marginTop: theme.spacing(3.5),
  marginBottom: theme.spacing(2.5),
  backgroundColor: theme.palette.common.white,
  ...($compact
    ? {
        border: 'none',
        borderRadius: 0,
        padding: theme.spacing(1.25),
      }
    : {
        border: `1px solid ${theme.palette.divider}`,
        borderTop: 'none',
        borderRadius: '0 0 4px 4px',
        padding: theme.spacing(1.25),
      }),
}));

export const NewFeaturesHeaderStack = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
}));

export const NewFeatureBadge = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 24,
  paddingLeft: theme.spacing(0.75),
  paddingRight: theme.spacing(0.75),
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
  borderRadius: theme.spacing(0.25),
  backgroundColor: theme.palette.aiChip?.main ?? theme.palette.success.main,
  fontSize: 11,
  fontWeight: 800,
  lineHeight: 1,
  letterSpacing: '0.06em',
  color: theme.palette.common.white,
}));

export const NewFeatureIcon = styled(FiberNew)(({ theme }) => ({
  fontSize: 24,
  color: theme.palette.aiChip?.main ?? theme.palette.success.main,
}));

export const NewFeaturesHeading = styled(Box)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 700,
  lineHeight: '32px',
  color: theme.palette.text.primary,
  margin: 0,
}));
